import React, { useState } from 'react'
import { toastSweetAlert } from '../Components/Helpers/ToastSweetAlert'
import Box from '../Components/Global/Box'
import CameraIcon from '../Assets/icons/Icon material-add-a-photo.svg'

const DragDropComponent = ({
  changeAction = () => {},
  onChange = () => {},
  files = [],
  setFiles = () => {},
  id = null,
  invalid = false,
  addClass = null,
  readOnly = false,
  disabled = false,
  allowedFileTypes = [],
  maxFiles = 1,
  error = null,
  newDropAttachment = false,
  editMode = false,
  setFilesEdit = false,
  label = 'Archivos adjuntos',
}) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDrop = (e) => {
    e.preventDefault()
    // let newFiles = []
    if (files && files.length >= maxFiles)
      return toastSweetAlert({
        mode: 'error',
        message: `Solo puedes subir ${maxFiles} ${
          maxFiles === 1 ? 'archivo' : 'archivos'
        }`,
      })

    let filesMap = files.map((file) => file)

    //Validate files
    for (let i = 0; i < e.dataTransfer.files.length; i++) {
      const file = e.dataTransfer.files[i]

      const getType = file.type.split('/')[1]

      const allowedTypes = allowedFileTypes

      if (!allowedTypes.includes(getType)) {
        return toastSweetAlert(
          {
            mode: 'error',
            message: 'Este tipo de archivo no esta permitido',
          },
          handleDragLeave()
        )
      }

      const allowedSize = 1024 * 1024 * 5

      if (file.size > allowedSize) {
        return toastSweetAlert(
          {
            mode: 'error',
            message: 'El archivo es muy grande',
          },
          handleDragLeave()
        )
      }

      filesMap.push(file)
      // newFiles.push(file)
    }
    if (filesMap.length > maxFiles) {
      //SLICE FILES TO MAX FILES
      filesMap = filesMap.slice(0, maxFiles)
    }
    const newFiles = [...e.dataTransfer.files]
    setFiles((prevFiles) => [
      ...prevFiles,
      ...newFiles.slice(0, maxFiles - prevFiles.length),
    ])
    changeAction(filesMap)
    onChange(filesMap)

    handleDragLeave()
  }

  const handleDragOver = (e) => {
    e.preventDefault()

    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.addEventListener('dragover', (e) => {
        e.preventDefault()
        dropzone.classList.add('dragging')
        setIsDragging(true)
      })
    }
  }

  const handleDragLeave = (e) => {
    // e.preventDefault()
    const dropzone = document.querySelector('.dropzone')
    if (dropzone) {
      dropzone.classList.remove('dragging')
      setIsDragging(false)
    }
  }

  const removeSkeleton = (index) => {
    const skeleton = document.getElementById(`skeleton-image-${index}`)
    if (skeleton) {
      skeleton.style.display = 'none'
    }
  }

  const handleRemoveFile = (index) => {
    const newFiles = files.filter((file, i) => i !== index)
    setFiles(newFiles)
    changeAction(newFiles)
    onChange(newFiles)
    handleDragLeave()
    if (editMode && setFilesEdit) {
      setFilesEdit(newFiles)
    }
  }

  return (
    <Box
      withCard={false}
      // btnSubmit={(e) => handleNext(e)}
      content={
        <>
          <div
            id={id}
            className={`col-12 container-drag-drop ${addClass} ${
              invalid && 'is-invalid border-danger'
            }`}
            // draggable={!readOnly && !disabled}
          >
            {newDropAttachment && (
              <div className="w-100 d-flex justify-content-between">
                <label htmlFor="dropzone">{label}</label>
                <label htmlFor="dropzone" className="text-end">
                  {files.length}/{maxFiles}
                  {/* {maxFiles > 1 ? ' archivos' : ' archivo'} */}
                </label>
              </div>
            )}
            <div
              className={`dropzone ${
                maxFiles > 1 ? 'size-all-col' : 'size-all-col-small'
              } ${addClass} ${
                invalid && 'is-invalid border-danger dropzone-invalid'
              }`}
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
            >
              {files.length > 0 ? (
                <div className="dropzone-image-container">
                  {files.map((file, index) => (
                    <div
                      key={index}
                      className="dropzone-container-image  dropzone-container-image-many"
                      style={{
                        textAlign: 'center',
                        position: 'relative',
                        gap: '5px',
                        borderRadius: '5px',
                      }}
                    >
                      <span
                        onClick={() => handleRemoveFile(index)}
                        className="dropzone--delete-button"
                      >
                        ×
                      </span>
                      {file.type.split('/')[0] === 'image' ? (
                        <img
                          src={file?.src ? file.src : URL.createObjectURL(file)}
                          alt={file.name}
                          title={file.name}
                          className="dropzone-image dropzone-image-many"
                          onLoad={() => removeSkeleton(index)}
                        />
                      ) : (
                        //preview pdf file
                        <iframe
                          title={file.name}
                          style={{
                            marginTop: '10px',
                          }}
                          src={URL.createObjectURL(file)}
                          type="application/pdf"
                          className="dropzone-image dropzone-image-many"
                          onLoad={() => removeSkeleton(index)}
                        />
                      )}
                      <p className="dropzone-filename-many">{file.name}</p>
                      <div
                        id={`skeleton-image-${index}`}
                        className="skeleton-image"
                      ></div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="dropzone-content">
                  {isDragging ? (
                    <div className="dropzone-dragging">
                      <i className="fas fa-cloud-upload-alt dropzone-icon"></i>
                      <p className="dropzone-text">Suelta el archivo</p>
                    </div>
                  ) : (
                    <div className="dropzone-message">
                      {newDropAttachment && (
                        <img src={CameraIcon} alt="camera-icon" />
                      )}
                      <p className="dropzone-text">
                        Arrastra y suelta archivos aquí
                      </p>
                      {newDropAttachment && (
                        <p className="dropzone-text-subtitle">
                          Formatos permitidos: {allowedFileTypes.join(', ')} -
                          Tamaño máximo: 5MB
                        </p>
                      )}
                      {invalid && (
                        <p className="dropzone-text text-danger">
                          {error && error.message}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              )}
              {!newDropAttachment && (
                <div className="dropzone-info">
                  <p>
                    Formatos permitidos: {allowedFileTypes.join(', ')} - Tamaño
                    máximo: 5MB
                  </p>
                  <p>
                    {files.length}/{maxFiles}
                    {maxFiles > 1 ? ' archivos' : ' archivo'}
                  </p>
                </div>
              )}
            </div>
          </div>
        </>
      }
    />
  )
}

export default DragDropComponent
